import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ShoppingTwoToneSvg from "@ant-design/icons-svg/es/asn/ShoppingTwoTone";
import AntdIcon from "../components/AntdIcon";
var ShoppingTwoTone = function ShoppingTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ShoppingTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ShoppingTwoTone.displayName = 'ShoppingTwoTone';
}
export default /*#__PURE__*/React.forwardRef(ShoppingTwoTone);